import $ from 'jquery';
export class LayerBox {
    constructor(layers) {
        this.layers = layers;
        this.initialized = false;
        this.sorted_layers = [];
        this.components = [];
        this.ui = $("#layerbox");
    }
    add_components(...components) {
        for (let component of components) {
            component.add_layers(this.layers);
            this.components.push(component);
        }
        this.build_ui();
    }
    build_ui() {
        if (this.initialized)
            return;
        const component_sort_render = (a, b) => {
            return a.render_index - b.render_index;
        };
        const component_sort_ui = (a, b) => {
            return a.ui_index - b.ui_index;
        };
        this.components.sort(component_sort_render);
        this.components.sort(component_sort_ui);
        for (let component of this.components) {
            this.ui.append(component.header);
            this.ui.append(component.body);
        }
        this.initialized = true;
    }
}
